<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-page-header @back="goBack" content="添加地址"></el-page-header>
        <el-form label-position="right" :rules="rules" ref="ruleForm" :model="item" label-width="auto">
            <el-form-item label="联系人姓名" prop="name">
                <el-input v-model="item.name" placeholder="请输入" class="el-input-default-width-220"></el-input>
            </el-form-item>
            <el-form-item label="联系人电话" prop="phone">
                <el-input v-model="item.phone" placeholder="请输入" class="el-input-default-width-220"></el-input>
            </el-form-item>
            <el-form-item label="选择地区" prop="areaId">
                <el-select v-model="item.province_id" clearable placeholder="请选择省" @change="provinceChange"
                           style="margin-right: 20px;">
                    <el-option v-for="item in province" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
                <el-select v-model="item.city_id" clearable placeholder="请选择市" @change="cityChange"
                           style="margin-right: 20px;">
                    <el-option v-for="item in city" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
                <el-select v-model="item.region_id" clearable placeholder="请选择县">
                    <el-option v-for="item in county" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="详细地址" prop="detail">
                <el-input v-model="item.detail" placeholder="请输入" class="el-input-default-width-220"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="checkSubmit">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                item: {
					orders: 1,
                    logo: ''
				},
                filterProps: {
                    value: 'id',
                    label: 'name',
                    emitPath: false,
                    checkStrictly: true
                },
                isLoad: false,
                logo: [],
                optionsParent: [],
                options: [],
                rules: {
                    phone: [
                        {required: true, message: '请输入联系电话', trigger: 'blur'},
                    ],
                    name: [
                        {required: true, message: '请输入联系人', trigger: 'blur'},
                    ],
                    detail: [
                        {required: true, message: '请输入详细地址', trigger: 'blur'},
                    ],
                    province_id: [
                        {required: true, message: '请选择地区', trigger: 'blur'},
                    ],
                    // logo: [
                    //     {required: true, message: '地址图标不存在'},
                    // ],
                },
                province: [],
                city: [],
                county: [],
            }
        },
        created() {
            this.gerProvince()
          this.loadData()
        },
        methods: {
            loadData: function () {
                if (this.isLoad) {
                    return
                }
                this.isLoad = !this.isLoad
                this.axios.get('/supplier/data/listIndustryForSelect', {},
				).then(res => {
					this.options = res.data.list;
                    return this.axios.get('/supplier/data/getCategoryTreeSupplier', {
                    })
                }).then(res => {
                    this.isLoad = !this.isLoad
                    this.optionsParent = res.data.tree
                }).catch(() => {
                    this.isLoad = !this.isLoad
                })
            },
            gerProvince() {
                let i = 0
                for (let key in this.$city.province_list) {
                    let obj = {
                        id: key,
                        name: this.$city.province_list[key]
                    }
                    this.province[i++] = obj
                }
            },
            provinceChange(data) {
                this.city = []
                this.county = []
                this.$set(this.item, 'cityId', '')
                this.$set(this.item, 'region_id', '')
                let subPro = data.substring(0, 2)
                let subCity = ''
                let i = 0
                for (let key in this.$city.city_list) {
                    subCity = key.substring(0, 2)
                    if (subCity === subPro) {
                        let obj = {
                            id: key,
                            name: this.$city.city_list[key]
                        }
                        this.city[i++] = obj
                    }
                }
            },
            cityChange(data) {
                this.county = []
                this.$set(this.item, 'region_id', '')
                let subCity = data.substring(0, 4)
                let subCounty = ''
                let i = 0
                for (let key in this.$city.county_list) {
                    subCounty = key.substring(0, 4)
                    if (subCounty === subCity) {
                        let obj = {
                            id: key,
                            name: this.$city.county_list[key]
                        }
                        this.county[i++] = obj
                    }
                }
            },
            // 后退一步
            goBack() {
                this.$router.back(-1)
            },
            checkSubmit(){
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        this.submit()
                    } else {
                        this.$message.warning("请检查表单信息是否正确");
                        return false;
                    }
                });
            },
            // 提交
            submit() {
                if (this.isLoad) {
                    return
                }
                this.isLoad = !this.isLoad

				let url = '/supplier/address/add'
				this.axios.post(url, this.item)
					.then(() => {
						this.isLoad = !this.isLoad
						this.$message.success({
							message: '保存成功'
						});
						this.goBack()
					})
					.catch(() => {
						this.isLoad = !this.isLoad
					})
            },
            uploadError() {
                this.$message.error({
                    message: '上传失败'
                });
            },
            beforeUpload(file) {
                var testmsg = file.type;
                const extension = (testmsg === "image/jpeg" || testmsg === "image/png");
                if (!extension ) {
                    this.$message({
                        message: "上传文件只能是jpg或png格式!",
                        type: "warning",
                    });
                }
                return extension;
            },
            uploadSuccess(key, res, file) {
                this.item[key] = res.data.fileInfo.external_url
            },
            uploadRemove: function () {
                this.logo = []
            }
        }
    }
</script>
<style scoped>
    .single-image .icon,.single-image img{
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        box-sizing: border-box;
        width: 148px;
        height: 148px;
        cursor: pointer;
        line-height: 146px;
        vertical-align: top;
    }
</style>
